<template>
  <div id="sidenav" class="hidden">
    <template v-for="topmenu in topmenus">
      <div
        :key="topmenu.id"
        v-if="topmenu.contents && topmenu.childEntries.rows.length > 0"
        class="sidenav__item"
      >
        <div class="sidenav__topmenu" @click="toggleTopmenu">
          <span>{{ topmenu.contents[0].title }}</span>
          <i class="fas fa-chevron-right"></i>
        </div>
        <div class="sidenav__sub">
          <template v-for="submenu in topmenu.childEntries.rows">
            <div
              v-if="submenu.contents"
              :key="submenu.id"
              @click="redirect(submenu.url)"
              :class="[{'active': currentPath == submenu.url}, 'sidenav__submenu']"
            >{{ submenu.contents[0].title }}</div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  computed: {
    topmenus() {
      return this.$store.state.topmenus;
    },

    currentPath() {
      return this.$route.path;
    }
  },

  watch: {
    currentPath(val) {
      $("#sidenav").addClass("hidden");
      if (val == "/") {
        document
          .getElementsByTagName("header")[0]
          .classList.remove("mobile-fill");
      }
    }
  },

  methods: {
    toggleTopmenu(event) {
      let topmenu =
        event.target.tagName == "I" || event.target.tagName == "SPAN"
          ? event.target.parentElement
          : event.target;
      let submenuList = topmenu.nextSibling;

      if (submenuList) {
        // Decide whether to show the current list or hide it
        let showList = !submenuList.classList.contains("is-active");

        this.hideSubmenuList();
        if (showList) {
          topmenu.childNodes[1].classList.remove("fa-chevron-right");
          topmenu.childNodes[1].classList.add("fa-chevron-down");
          submenuList.classList.add("is-active");
        }
      }
    },

    // Hide all active lists
    hideSubmenuList() {
      let topmenuList = document.getElementsByClassName("sidenav__topmenu");
      for (var i = 0; i < topmenuList.length; i++) {
        let topmenu = topmenuList[i];
        let submenuList = topmenu.nextSibling;
        if (submenuList && submenuList.classList.contains("is-active")) {
          topmenu.childNodes[1].classList.remove("fa-chevron-down");
          topmenu.childNodes[1].classList.add("fa-chevron-right");
          submenuList.classList.remove("is-active");
        }
      }
    },

    redirect(url) {
      this.$router.push(url);
    }
  }
};
</script>
